var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"text-uppercase text-light font-weight-light mt-4 heading",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('hr',{staticClass:"bg-light"})])}
var staticRenderFns = []

export { render, staticRenderFns }